import { render, staticRenderFns } from "./FloatingStepsDesktop.vue?vue&type=template&id=475eb9ba&scoped=true&"
import script from "./FloatingStepsDesktop.vue?vue&type=script&lang=ts&"
export * from "./FloatingStepsDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./FloatingStepsDesktop.vue?vue&type=style&index=0&id=475eb9ba&scoped=true&lang=css&"
import style1 from "./FloatingStepsDesktop.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475eb9ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VHover,VIcon,VMenu,VRow})
